<template>
  <div>
    <p class="px-2 py-1" >Attachment: <b>{{ message.AttachmentFile.Name }}</b></p>
    <a class="attachment-link" href="javascript:;" v-on:click="openGenericFileAttachment" :title="message.AttachmentFile.Name">
      <div class="card bg-light border-0">
        <div class="card-body p-1">
          <div class="d-flex flex-row">
            <div class="p-2">
              <img v-if="hasFileIconForExtension(message.AttachmentFile.Extension)" :src="'static/assets/img/FileFormatIcons/'+message.AttachmentFile.Extension+'.png'" class="file-icon" />
              <img v-else :src="'static/assets/img/FileFormatIcons/unknown.png'" class="file-icon" />
            </div>
            <div class="p-2">
              <div class="file-info">
                <div class="truncate-text">{{message.AttachmentFile.Name}}</div>
                <i class="fa fa-external-link-square"></i>&nbsp;View {{message.AttachmentFile.Type}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import {FileFormatIcons} from '@/lib/utilities/enums'
export default {
    name: 'genericFileUpload',
    props: ['openGenericFileAttachment'],
    data: function (){
        return {
            message: null
        }
    },
    created(){
        this.message = this.$parent._props.message;
    },
    methods: {
            hasFileIconForExtension: function (extension) {
        return extension && FileFormatIcons.indexOf(extension.toLowerCase()) >= 0;
      }
    }
}
</script>

<style lang="scss" scoped>

.attachment-card {
  // max-width: 100%;
  width: auto;
  .card-header {
    background-color: $white;
  }
  a {
    color: $blue-lt;
    text-decoration: none;
    &:hover {
      color: $blue-lt;
    }
  }
}


.file-icon {
    width: 40px;
    height: 40px;
    margin: 5px 5px 5px 0;
}
</style>




// WEBPACK FOOTER //
// src/components/Messenger/MessageList/Message/MessageAttachment/GenericFilePayload.vue